import type { IconProps } from '@phosphor-icons/react'

/**
 * The icon defaults every shared button applies to the icons inside it, through Phosphor's
 * `IconContext`. Icons inside a button leave `weight` unset so this decides it in one place; a
 * prop still wins, which is how a filled icon stays filled.
 *
 * A provider replaces the library's default context outright rather than merging into it, so the
 * other defaults are restated here — without `size`, an icon given no size would lose its `1em`.
 */
export const BUTTON_ICON_CONTEXT: IconProps = {
  color: 'currentColor',
  size: '1em',
  weight: 'bold',
  mirrored: false,
}
